module.exports = __webpack_public_path__ + "img/plan3_acceptable.7ba5bcff.png";